module.exports = __webpack_public_path__ + "static/media/thumb_me_dark.f877a2a8.JPG";